import { useGame } from "../../app/GameProvider.js";
import { StatIcon } from "../../components/StatIcon.js";
import { fatigueLimit } from "../../domain/run/fatigueLimit.js";

export function TopBar() {
  const { state, dispatch } = useGame();
  const run = state.run;
  if (!run) return null;

  return (
    <header className="topbar">
      <span className="stat is-fatigue">
        <StatIcon name="fatigue" />
        疲労 <b>{run.fatigue}</b> / {fatigueLimit(run.organizations)}
      </span>
      <button type="button" className="btn" onClick={() => dispatch({ type: "OPEN_OVERLAY", overlay: "deck" })}>
        詳細
      </button>
    </header>
  );
}
